import * as types from "../types";
import { requestAuth, axiosAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import axios from "axios";
import { ActionsCreators } from "../../actions";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetDisplayGroupsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_DISPLAYGROUPS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_DISPLAYGROUPS_COMPLETED, payload: null });
        if (pageSize < 0) { return onSuccess(null); }
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DisplayGroups/OrganizationDisplayGroups/" + store().currentuser.currentorganization.id + "?"
            + "pageNumber=" + pageNumber
            + "&pageSize=" + pageSize
            + (sortExpression ? "&sortExpression=" + sortExpression : "")
            + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_DISPLAYGROUPS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_DISPLAYGROUPS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },

    GetSecondaryDisplayGroupsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetDisplayGroupsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },
    GetCallCentersList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        dispatch({ type: types.GET_CALLCENTERS_COMPLETED, payload: null });
        if (pageSize < 0) { return onSuccess(null); }
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCenters/OrganizationCallCenters/" + store().currentuser.currentorganization.id + "?"
            + "pageNumber=" + pageNumber
            + "&pageSize=" + pageSize
            + (sortExpression ? "&sortExpression=" + sortExpression : "")
            + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_CALLCENTERS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    SaveCallCentersPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.callcenters;
        dispatch({ type: types.GET_CALLCENTERS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },
    GetSecondaryCallCentersList: (onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_CALLCENTERS_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCenters/AllOrganizationCallCenters/" + store().currentuser.currentorganization.id,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_CALLCENTERS_SECONDARY_COMPLETED, payload: { results: data } });
            return onSuccess({ results: data });
        }).catch((data) => {
            console.log(data);
        });
    },
    GetSecondaryFreeCallLinkList: (onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_FREECALLLINK_SECONDARY_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/AllOrganizationFreeCallLinks/" + store().currentuser.currentorganization.id,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_FREECALLLINK_SECONDARY_COMPLETED, payload: { results: data } });
            return onSuccess({ results: data });
        }).catch((data) => {
            console.log(data);
        });
    },
    GetFreeCallLinksList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        dispatch({ type: types.GET_FREECALLLINKS_COMPLETED, payload: null });
        if (pageSize < 0) { return onSuccess(null); }
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/OrganizationFreeCallLinks/" + store().currentuser.currentorganization.id + "?"
            + "pageNumber=" + pageNumber
            + "&pageSize=" + pageSize
            + (sortExpression ? "&sortExpression=" + sortExpression : "")
            + (filterExpression ? "&filterExpression=" + filterExpression : "")
            + "&permanent=true"
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_FREECALLLINKS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    SaveFreeCallLinksPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.freecalllinks;
        dispatch({ type: types.GET_FREECALLLINKS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },
    GetReCallLinksList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        dispatch({ type: types.GET_RECALLLINKS_COMPLETED, payload: null });
        if (pageSize < 0) { return onSuccess(null); }
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/OrganizationFreeCallLinks/" + store().currentuser.currentorganization.id + "?"
            + "pageNumber=" + pageNumber
            + "&pageSize=" + pageSize
            + (sortExpression ? "&sortExpression=" + sortExpression : "")
            + (filterExpression ? "&filterExpression=" + filterExpression : "")
            + "&permanent=false"
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_RECALLLINKS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    SaveReCallLinksPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.freecalllinks;
        dispatch({ type: types.GET_RECALLLINKS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },
    CallCentersForCallLink: (onSuccess, typeCallLink, autoAddOwnCallCenter) => async (dispatch, store) => {
        await requestAuth(`${appSettings.SKALINKAPIURL}/api/CallCenters/CallCentersForCallLink/` + `${store().currentuser.currentorganization.id}/` + `${typeCallLink === "permanent" ? -1 : store().currentuser.user.id}/` + `${autoAddOwnCallCenter}`, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    GetDecisionTreesList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {

        dispatch({ type: types.GET_DECISIONTREES_COMPLETED, payload: null });
        if (pageSize < 0) { return onSuccess(null); }
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DecisionTrees/OrganizationDecisionTrees/" + store().currentuser.currentorganization.id + "?"
            + "pageNumber=" + pageNumber
            + "&pageSize=" + pageSize
            + (sortExpression ? "&sortExpression=" + sortExpression : "")
            + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_DECISIONTREES_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    SaveDecisionTreesPagination: (paginationType) => (dispatch, store) => {
        const data = store().monitoring.decisiontrees;
        dispatch({ type: types.GET_DECISIONTREES_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetDisplayGroup: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DisplayGroups/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },
    GetDecisionTree: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DecisionTrees/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch((data) => {
            console.log(data);
        });
    },

    DeleteDisplayGroup: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DisplayGroups/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.dgDeleted);
            if (onSuccess) { onSuccess(data); }
        }).catch((data) => {
            console.log("error", data);
        });
    },
    DeleteCallCenter: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCenters/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.ccDeleted);
            if (onSuccess) { onSuccess(data); }
        }).catch((data) => {
            console.log("error", data);
        });
    },
    DeleteFreeCallLink: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.callLinkDeleted);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },
    DeleteDecisionTree: (Id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DecisionTrees/" + Id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.dgDeleted);
            if (onSuccess) { onSuccess(data); }
        }).catch((data) => {
            console.log("error", data);
        });
    },

    EditDisplayGroup: (changedDisplayGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DisplayGroups/" + changedDisplayGroup.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedDisplayGroup),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.dgSaved);
            onSuccess(data);
        }).catch((data) => {
            console.log("error", data);
        });
    },
    EditCallCenter: (filesList, changedCallCenter, onSuccess) => (dispatch, store) => {
        const formData = new FormData();
        filesList.forEach(file => {
            formData.append("files", file);
        });
        formData.append("contentObjAsString", JSON.stringify(changedCallCenter));

        axiosAuth(appSettings.SKALINKAPIURL + "/api/CallCenters/" + changedCallCenter.id,
            {
                method: "PUT",
                data: formData,
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                }
            }
        )
            .then(function (response) {
                toast.success(strings.ccSaved);
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                console.log("error", error);
            });
    },
    EditFreeCallLink: (changedCallLink, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/" + changedCallLink.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedCallLink),
            method: "PUT"
        }).then((data) => {
            onSuccess(data);
        }).catch((data) => {
            console.log("error", data);
        });
    },
    EditDecisionTree: (filesList, changedDisplayGroup, onSuccess) => (dispatch, store) => {
        const formData = new FormData();
        filesList.forEach(file => {
            formData.append("files", file);
        });
        formData.append("contentObjAsString", JSON.stringify(changedDisplayGroup));

        /* Use axios for upload progress */
        axiosAuth(appSettings.SKALINKAPIURL + "/api/DecisionTrees/" + changedDisplayGroup.id,
            {
                method: "PUT",
                data: formData,
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                }
            }
        )
            .then(function (response) {
                toast.success(strings.dgSaved);
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                console.log("error", error);
            });
    },

    CreateDisplayGroup: (newDisplayGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DisplayGroups", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newDisplayGroup),
            method: "POST"
        }).then((data) => {
            toast.success(strings.dgSaved);
            onSuccess(data);
        }).catch((data) => {
            console.log("error", data);
        });
    },
    CreateCallCenter: (filesList, newCallCenter, onSuccess) => (dispatch, store) => {
        const formData = new FormData();
        filesList.forEach(file => {
            formData.append("files", file);
        });
        formData.append("contentObjAsString", JSON.stringify(newCallCenter));

        axiosAuth(appSettings.SKALINKAPIURL + "/api/CallCenters",
            {
                method: "POST",
                data: formData,
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                }
            }
        )
            .then(function (response) {
                toast.success(strings.ccSaved);
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                console.log("error", error);
            });
    },
    CreateFreeCallLink: (newCallLink, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newCallLink),
            method: "POST"
        }).then((data) => {
            onSuccess(data);
        }).catch((data) => {
            console.log("error", data);
        });
    },
    CreateDecisionTree: (newDisplayGroup, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/DecisionTrees", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newDisplayGroup),
            method: "POST"
        }).then((data) => {
            toast.success(strings.dgSaved);
            onSuccess(data);
        }).catch((data) => {
            console.log("error", data);
        });
    }

};
